<alerts></alerts>
<div
    id="root"
    cdkDropListGroup
    [ngClass]="{
        'nav-expanded': navExpanded,
        'no-navigation': auth.loggedOut$ | async,
        'additional-sidebar': layout.sideBar && layout.isSideBarVisible,
        'signup-without-header': isPageWithoutHeader(),
        'banner-signup__demo': demo.isDemoHost,
        'steps-navigation': isOnboardingShowCreateApp,
        'no-transition': isInternalDashboard,
    }"
    [class.scrolled]="isScrolledContent"
    [class.forced]="layout.forcedShowAsScrolled"
    class="root"
>
    <ng-container *ngTemplateOutlet="sideNavTemplate || baseNavigation"></ng-container>

    <ng-template #baseNavigation>
        <nav *ngIf="auth.loggedIn$ | async" transitionReset #nav>
            <navigation-side-bar
                [currentUser]="auth.currentUser$ | async"
                [faqUrl]="auth.currentFAQUrl$ | async"
                [ngClass]="{'nav-expanded': navExpanded}"
                [navExpanded]="navExpanded"
                [currentApp]="selectedAppService.selectedApp$ | async"
                [nav]="nav"
            ></navigation-side-bar>
        </nav>
    </ng-template>

    <header [class.scrolled]="isScrolledContent" [class.forced]="layout.forcedShowAsScrolled" *ngIf="!isPageWithoutHeader()">
        <navigation-toggle
            [class.nav-expanded]="navExpanded"
            [(navExpanded)]="navExpanded"
            *ngIf="auth.loggedIn$ | async"
        ></navigation-toggle>
        <div class="logo-placeholder">
            <ng-container *ngIf="auth.currentUser$ | async; else signLogo">
                <a [href]="'https://appodeal.com/home'" [target]="'_blank'" class="logoLink">
                    <svg-image name="appodeal-new-logo" class="header-logo"></svg-image>
                </a>
                <page-title-content [title]="layout.title$ | async" [titleItems]="layout.titleItems$ | async">
                    <settings-page *ngIf="isMonetizationPage()"></settings-page>
                </page-title-content>
                <ng-container *ngIf="isReportPage()">
                    <div class="saved-reports">
                        <div class="saved-reports__cell saved-reports__cell-select">
                            <header-report-filters></header-report-filters>
                        </div>
                        <!-- <div class="saved-reports__cell saved-reports__cell-rename">
                            <rename-reports-filters></rename-reports-filters>
                        </div> -->
                        <div class="saved-reports__cell">
                            <save-reports-filters></save-reports-filters>
                        </div>
                    </div>
                </ng-container>
                <div class="header-content">
                    <ng-container *ngIf="layout.headerContent" [ngTemplateOutlet]="layout.headerContent"></ng-container>
                </div>
            </ng-container>

            <ng-template #signLogo>
                <a href="https://appodeal.com/" class="logoLink">
                    <svg-image name="sign-new-logo" class="header-logo"></svg-image>
                </a>
            </ng-template>
        </div>
        <div class="user-options" *ngIf="auth.currentUser$ | async as currentUser; else signIn">
            <user-bar [user]="currentUser"></user-bar>
        </div>
        <ng-template #signIn>
            <div class="user-options sign">
                <span class="btn-group">
                    <a [href]="appUrls.SIGN_UP | appUrl" class="button button--primary-inverted sign-up" id="signUpBtn">
                        {{ 'header.signUpBtn' | i18next }}
                    </a>
                    <a [routerLink]="appUrls.SIGN_IN | appUrl" class="button button--primary-inverted sign-in" id="signInBtn">
                        {{ 'header.signInBtn' | i18next }}
                    </a>
                </span>
            </div>
        </ng-template>
    </header>

    <div class="banner-signup__wrap" *ngIf="demo.isDemoHost">
        <ng-template #signUpHeaderBanner>
            <img src="/images/signup/signup-banner-logo.svg" class="banner-signup__img" alt="" />
            <span class="title-h3">{{ 'signUp.banner.txt' | i18next }}</span>
            <button class="button button--primary-inverted" (click)="navigateToSignFromDemoUpPage()">
                {{ 'footer.btns.signUp' | i18next }}
            </button>
        </ng-template>
        <ng-container *ngIf="bridgeService.isUserLoggedIn() | async; else signUpHeaderBanner">
            <leave-demo-account></leave-demo-account>
        </ng-container>
    </div>

    <ng-container *ngIf="layout.sideBar && layout.isSideBarVisible" [ngTemplateOutlet]="layout.sideBar"></ng-container>
    <section id="content" [class.no-padding]="layout.frameWithoutPaddings$ | async" #content>
        <router-outlet-loading></router-outlet-loading>
    </section>

    <app-footer
        *ngIf="layout.footerVisible$ | async"
        [termsLink]="termsLink"
        [buildInfo]="buildInfo"
        [currentUser]="auth.currentUser$ | async"
        [class.visibleMobFooter]="layout.visibleMobFooter$ | async"
        class="footer"
        [isPageWithoutHeader]="isPageWithoutHeader()"
    ></app-footer>
</div>

<overlay-outlet></overlay-outlet>
<tooltip-outlet></tooltip-outlet>
<fake-intercom *ngIf="intercom.disabled"></fake-intercom>
